// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.project-info__inner-sections[data-v-cc244164] {\n  position: relative;\n}\n.project-info__inner-sections[data-v-cc244164]:first-child {\n  padding-bottom: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
